module.exports = __webpack_public_path__ + "img/noDetail.502428c5.png";